import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { getSignupErrorMessage } from "Signups/SharedComponents/getSignupErrorMessage";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks.js";
import { useGetSignupListType } from "Signups/SignupView/utils/useGetSignupListType";
import { useSignups } from "Signups/state";

import FnrButton3 from "UI/FnrButton3";
import { SharedResizing } from "UI/SharedResizingArea3";

import { Content, P, RowBetween, Wrapper } from "./Components";
import { personType } from "./personType";
import removeFromSignup from "./removeFromSignup";

NoRefund.proptype = {
  usersToRemove: PropTypes.string,
  displayName: PropTypes.string,
  currentSignupItem: PropTypes.shape({
    ID: PropTypes.number,
    name: PropTypes.string,
  }),
  closeModal: PropTypes.func,
  removalType: PropTypes.oneOf([
    personType.USER,
    personType.HOUSEHOLD_MEMBER,
    personType.ADDITIONAL_NAME,
    "slot",
  ]),
};

export default function NoRefund({
  usersToRemove,
  displayName,
  currentSignupItem,
  closeModal,
  removalType,
  user,
  household,
  additionalName,
  signupListID,
  setError,
}) {
  //
  const [, dispatch] = useSignups();
  const { isItemType } = useGetSignupListType();
  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  React.useEffect(() => {
    console.log("currentSignupItem", currentSignupItem);
  }, [currentSignupItem]);
  const handleRemove = () => {
    // send request to API, then close modal
    let postData;

    if (removalType === personType.ADDITIONAL_NAME) {
      postData = {
        additionalNameID: additionalName.additionalNameID,
        signedUpViaID: 5,
        signupItemID: currentSignupItem.ID,
        refund: false,
      };
    } else if (removalType === personType.HOUSEHOLD_MEMBER) {
      postData = {
        signupItemID: currentSignupItem.ID,
        userID: user.userID,
        signedUpViaID: 5,
        refund: false,
      };
    } else if (removalType === personType.USER) {
      postData = {
        signupItemID: currentSignupItem.ID,
        userID: user.userID,
        signedUpViaID: 5,
        refund: false,
      };
    } else if (removalType === personType.HOUSEHOLD) {
      postData = {
        signupListID: signupListID,
        signupItemID: currentSignupItem.ID,
        householdID: household.householdID,
        signedUpViaID: 5,
        refund: false,
      };
    }

    removeFromSignup({ signupID: signupListID, postData, removalType })
      .then((res) => {
        if (postData?.signupItemID) {
          getSignupItem(postData.signupItemID);
        }
        dispatch({
          type: "Other User Signup Updated",
          signupList: res.signupList,
          allSignupLists: res.allSignupLists,
        });
        closeModal();
      })
      .catch((err) => {
        setError(getSignupErrorMessage(err?.error));
      });
  };

  const usersToRemoveCount = usersToRemove.length;
  const itemTypeAddAnS =
    usersToRemoveCount > 1 && !currentSignupItem?.name.endsWith("s");

  const headingText = isItemType ? (
    <P>
      Are you sure you want to remove{" "}
      <Bold>
        {usersToRemoveCount} {currentSignupItem?.name}
        {itemTypeAddAnS ? "s" : ""}
      </Bold>{" "}
      for {displayName}?
    </P>
  ) : (
    <P>
      Are you sure you want to remove <Bold>{displayName}</Bold> from{" "}
      {currentSignupItem?.name}?
    </P>
  );

  const filteredUsersToRemove = usersToRemove.filter(
    (user) => user.trim() !== displayName
  );
  const othersToRemove = filteredUsersToRemove.reduce((acc, cur, i) => {
    let trimmedCur = cur.trim();
    if (i === 0) return trimmedCur;
    if (usersToRemove?.length === 2 && i === 1)
      return `${acc} and ${trimmedCur}`;
    if (i === filteredUsersToRemove?.length - 1)
      return `${acc}, and ${trimmedCur}`;
    return `${acc}, ${trimmedCur}`;
  }, "");

  // This text doesn't make sense for items-type Signups (or if there are no others being removed)
  const showOthersToRemove = !isItemType && othersToRemove?.length > 0;

  return (
    <SharedResizing>
      <Wrapper key={1}>
        <Content>
          <AltHeading>{headingText}</AltHeading>
          {showOthersToRemove ? (
            <P>
              <Bold>{othersToRemove}</Bold> will also be removed.
            </P>
          ) : (
            <div style={{ height: 10 }} />
          )}

          <RowBetween>
            <FnrButton3 onClick={closeModal}>Cancel</FnrButton3>
            <FnrButton3 color="red" onClick={handleRemove}>
              {usersToRemove?.length > 1 ? "Yes, remove all" : "Yes, remove"}
            </FnrButton3>
          </RowBetween>
        </Content>
      </Wrapper>
    </SharedResizing>
  );
}

const Bold = styled.span`
  font-weight: 600;
`;
const AltHeading = styled.div`
  font-size: 1.35rem;
`;
